import { render, staticRenderFns } from "./mainGroup.vue?vue&type=template&id=68f22c15"
import script from "./mainGroup.vue?vue&type=script&lang=js"
export * from "./mainGroup.vue?vue&type=script&lang=js"
import style0 from "./mainGroup.vue?vue&type=style&index=0&id=68f22c15&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0_supports-color@_e2va3oitd2br7adsazclseazuu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports